var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "bugReportModal",
      attrs: {
        id: "show-bug-report-modal",
        "cancel-title": _vm.$t("Cancel"),
        "ok-title": _vm.$t("Send.report"),
        title: _vm.$t("Report.a.bug"),
        "cancel-variant": "danger"
      },
      on: { hidden: _vm.resetModal, ok: _vm.handleOk, show: _vm.resetModal }
    },
    [
      _c(
        "form",
        { ref: "formReportBug", on: { submit: _vm.handleSubmit } },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                "invalid-feedback": _vm.form.commentaire.invalidFeedback,
                label: _vm.$t("Report.a.bug.label"),
                "label-for": "reportBug-input"
              }
            },
            [
              _c("b-form-textarea", {
                attrs: {
                  id: "reportBug-input",
                  placeholder: _vm.$t("Report.a.bug.placeholder")
                },
                model: {
                  value: _vm.form.commentaire.value,
                  callback: function($$v) {
                    _vm.$set(_vm.form.commentaire, "value", $$v)
                  },
                  expression: "form.commentaire.value"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f1af83c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f1af83c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/b122/ShowBugReportModal.vue
// module id = 8Nsa
// module chunks = 0